import { Box, PopoverAnchor, PopoverTrigger, Skeleton } from "@chakra-ui/react";
import { ProgressBarOurWorkSpendPercent } from "@components/ui-kit";
import { TooltipComplexOurWork } from "@components/widgets/TooltipComplexOurWork";
import {
  OurWorkProgressBar,
  type OurWorkProgressBarProps,
} from "@src/components/widgets/OurWorkProgressBar";
import { can } from "@src/utils/components/permissions";
import { currency, inputPercent, percent } from "@src/utils/formatters";
import type { Project, SubRow } from "../../models";

type OurWorkProps = {
  totalBudget: number;

  spentBudgetPercent: number;
  spentBudget: number;
  spentTime: number;

  progressPercent: number;
  progress: number;
  spentTimeEstimate: number;

  project?: Project;
  editable?: boolean;
} & ({ item: SubRow; editable: true } | { item?: SubRow; editable?: false });

export const OurWork = (props: OurWorkProps) => {
  const onSubmitProgress = (
    data: Parameters<
      NonNullable<OurWorkProgressBarProps["onSubmitProgress"]>
    >[0],
  ) => {
    const { item, project } = props;

    if (item) {
      data.changedWorkInProgressItemStats.forEach((i) => {
        if (
          i.work_in_progress_id ===
          item.lastWorkInProgressItemStat?.work_in_progress_id
        ) {
          item.updateCurrentWorkInProgressItemStat(i);
        }
      });
    }

    if (project) {
      project.updateCurrentWorkInProgressItemStat(
        data.lastWorkInProgressProjectStat,
      );
    }
  };

  return (
    <TooltipComplexOurWork
      timeTracking={{
        percent: props.spentBudgetPercent,
        value: props.spentBudget,
        time: props.spentTime,
      }}
      progress={{
        percent: props.progressPercent,
        value: props.progress,
        time: props.spentTimeEstimate,
      }}
    >
      <PopoverTrigger>
        <Skeleton
          isLoaded={
            !!props.spentBudget ||
            !!props.totalBudget ||
            !!props.spentBudgetPercent
          }
        >
          <Box>
            <div className="text-lg">
              {currency.formatByWorkspace(props.spentBudget)} /{" "}
              {currency.formatByWorkspace(props.totalBudget)}{" "}
              <span className="text-gray-600">
                ({percent.format(props.spentBudgetPercent)})
              </span>
            </div>
            <ProgressBarOurWorkSpendPercent
              progress={inputPercent.format(props.spentBudgetPercent)}
            />
          </Box>
        </Skeleton>
      </PopoverTrigger>

      {can(["wip_read_all", "wip_read_team", "wip_read_own"]) && (
        <PopoverAnchor>
          <Skeleton
            isLoaded={props.progressPercent >= 0 || props.progressPercent <= 0}
          >
            <div className="pt-2">
              <OurWorkProgressBar
                progress={props.progressPercent}
                budgetItemId={props.item?.id}
                editable={props.editable}
                onSubmitProgress={onSubmitProgress}
              />
            </div>
          </Skeleton>
        </PopoverAnchor>
      )}
    </TooltipComplexOurWork>
  );
};
